/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Form_LabelInputs */



/**
* | output |
* | --- |
* | "File import form" |
*
* @param {File_Import_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_form_label = /** @type {((inputs?: File_Import_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("File import form")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiimportformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di importazione file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма импорта файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de importación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件导入表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルインポートフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल आयात फ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de importação de arquivos")
	return /** @type {LocalizedString} */ ("File import form")
});